import { axiosInstance } from ".."

const partnerLocations = async () =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`/public/geolist/partnerCity`).then((res) => { 
            console.log(res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default partnerLocations;